/**
 * Сбрасывает значения всех полей формы к исходным.
 *
 * @param {HTMLFormElement} form Форма, которую необходимо сбросить. По умолчанию используется первая найденная форма на странице.
 */
export function cleanForm(form = document.querySelector('form')) {
  form.reset();
}

export function appendFormData(formData, data, parentKey) {
  if (data && typeof data === 'object' && !(data instanceof File)) {
    Object.keys(data).forEach((key) => {
      appendFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
    });
  } else {
    formData.append(parentKey, data);
  }
}

export async function validateForm({ elem, event, customValidate, disableValidate = false }) {
  if (disableValidate) return true;

  const closestForm = elem.closest('form') ?? elem.querySelector('form');
  if (!closestForm) return true;

  if (typeof customValidate !== 'undefined' && customValidate) {
    const val = await customValidate.bind(this)();
    if (!val) return false;
  }

  const activeInputs = Array.from(closestForm.querySelectorAll('input, select, textarea')).filter((input) => !input.disabled && !input.readOnly);

  for (let input of activeInputs) {
    if (input.type === 'hidden' && input.required) {
      if (!input.value) {
        showInputError({ input: input, message: 'Заполните поле' });
        return;
      }
    }

    if (input.hasAttribute('verified')) {
      const verifiedValue = input.getAttribute('verified');
      if (verifiedValue !== '1' && verifiedValue.toLowerCase() !== 'true') {
        const message = verifiedValue !== '' ? verifiedValue : 'Поле не прошло проверку';
        showInputError({ input: input, message: message });
        return false;
      }
    }
    // debugger
    if (!input.checkValidity()) {
      if (event) {
        return event();
      } else {
        input.reportValidity(); // Показываем стандартное сообщение валидации
        return false;
      }
    }
  }

  return true;
}
